const NETWORK_STATUS_CONSTANTS = {
    PING_TRY_COUNT: 3
}

export { NETWORK_STATUS_CONSTANTS }